/*
 * Navigation tabs component
 *
 * @param {String} tab Active tab
 * @param {Boolean} disabled Disabled tab
 *
 * @return {Element}
 */
<template>
  <div>
    <ul class="nav nav-tabs reward-nav-tabs" id="tabTitle">
      <template v-for="item in navTabs">
        <li :id="item.id" :class="activeTab(item.id)" :key="item.id" v-if="disabled && item.id !== 'top'" class="disabled">
          <a>
            {{ item.name }}
          </a>
        </li>
        <li :id="item.id" v-else :class="activeTab(item.id)" :key="item.id" @click="changeTab(item.id)">
          <a>
            {{ item.name }}
          </a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import tabs from '@/common/affiliate-tabs'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      navTabs: tabs
    }
  },
  props: {
    tab: {
      type: String,
      default: 'top'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /*
     * Check tab is active or not
     *
     * @param {String} tabName Tab's name
     *
     * @return {String}
     */
    activeTab (tabName) {
      return this.tab === tabName ? 'active' : ''
    },
    /*
     * Change tab
     *
     * @param {String} tabName Tab's name
     *
     * @return void
     */
    changeTab (tabName) {
      let availableTabs = ['top', 'affiliater-list', 'reward-info']
      if (availableTabs.includes(tabName)) {
        let logParamsName = eventCode.affiliate.top_tab.show
        if (tabName === 'affiliater-list') {
          logParamsName = eventCode.affiliate.list_affiliate_tab.show
        } else if (tabName === 'reward-info') {
          logParamsName = eventCode.affiliate.reward_info_tab.show
        }

        setTimeout(() => {
          $(`#${tabName}`).addClass('disabled-tab')
        }, 700)

        let logParams = {
          name: logParamsName,
          properties: {}
        }
        EventService.postTrackLog(logParams)
      }

      this.$router.push(`/affiliate/${tabName}`)
    }
  },
  mounted () {
    $(`#${this.tab}`).addClass('disabled-tab')
  }
}
</script>

<style scoped>
.disabled-tab {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/view/affiliate/NavTabs.vue